/* Optional: The first view that is shown when you enter the app. This is conditionally rendered depending on
   user state (logged in or not) */
import Logo from '../../components/logo.jsx';
import { Login } from './logInview.jsx';
import { Signup } from './signUpView.jsx';
import Loader from '../../components/loader.jsx';
import GoogleSignInButton from '../../components/GoogleButton.jsx';


export function LandingPageView(props){
   function login() {    
      props.clearErrors();
      props.toggle("login");
   }
   function signup() {
      props.clearErrors();
      props.toggle("signup");
   }
   return (
   <div className="min-h-screen flex items-center justify-center p-4 bg-sky-50">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-30 h-30 mb-4 shadow-lg bg-sky-50 rounded-3xl">
            <Logo/> 
          </div>
          <h1 className="text-blue-900 mb-2">Clubbing Books</h1>
          <p className="text-blue-700">Connect with readers, share stories, and grow together</p>
        </div>
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-blue-100 ">
          <div>
            <div className="flex gap-2 mb-4 items-center">
              <button
                className={`flex items-center justify-center flex-1 py-2 px-4 !rounded-lg transition-colors ${
                  props.signToggle === "login"
                    ? 'bg-blue-600 text-white'
                    : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
                }`}
                onClick={login}
              >
                Login
              </button>
              <button
                  className={`flex items-center justify-center flex-1 py-2 px-4 !rounded-lg transition-colors ${
                    props.signToggle === "signup"
                    ? 'bg-blue-600 text-white'
                    : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
                  }`}
                  onClick={signup}
              >
                Sign Up
              </button>
            </div>
            <div className="flex justify-center">
              <GoogleSignInButton onGoogleSignIn={props.onGoogleSignIn}/>
            </div>
            {(props.user.status ==="rejected" && props.user?.error?.networkError) && (
              <div className="text-red-700 text-sm mt-2">
                {props.user?.error?.networkError}
              </div>
            )}
          </div>
          <div className="mt-6 pt-6 border-t border-blue-100">
            {props.user.status === "pending" ? 
                <Loader /> : props.signToggle === 'login' ? (
                <Login 
                  setEmail={props.setEmail} 
                  setPassword={props.setPassword} 
                  signIn={props.signInUser}
                  emailError={props.user?.error?.emailError}
                  passwordError={props.user?.error?.passwordError}
                  />) : 
                  (<Signup 
                  signUpUser={props.signUpUser} 
                  setEmail={props.setEmail} 
                  setFName={props.setFName} 
                  setLName={props.setLName} 
                  setPassword={props.setPassword} 
                  setComfirmPassword={props.setComfirmPassword} 
                  emailError={props.user?.error?.emailError}
                  fNameError={props.user?.error?.fNameError}
                  lNameError={props.user?.error?.lNameError}
                  passwordError={props.user?.error?.passwordError}
                  confirmPasswordError={props.user?.error?.confirmPasswordError}
                />)}
          </div>
        </div>
      </div>
    </div>







          
      );
   }